import * as React from 'react';
/**
 *
 * Original name: back ten seconds
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=31221%3A9697
 *
 */
export const BackTenSecondsLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M8.5 10V8.5H6.771c1.062-1.338 2.796-2 5.229-2 4.374 0 6.5 2.126 6.5 6.5H20c0-5.159-2.841-8-8-8-2.973 0-5.169.95-6.5 2.74V5.5H4V10h4.5Zm2.335 9.418v-1.26H9.386v-5.157h-1.08c-.108.693-.432 1.026-1.296 1.08v1.017h1.053v3.06h-1.52v1.26h4.292Zm3.482.153c1.863 0 3.141-1.044 3.141-3.159v-.342c0-2.088-1.296-3.204-3.15-3.204-1.899 0-3.132 1.143-3.132 3.213v.333c0 2.142 1.188 3.16 3.141 3.16Zm-.009-1.197c-1.17 0-1.764-.666-1.764-1.989v-.27c0-1.377.594-2.06 1.773-2.06 1.143 0 1.773.665 1.773 2.06v.261c0 1.395-.648 1.998-1.782 1.998Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
